import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ModalExit } from "src/app/core/enums";
import { ModalHandler } from "src/app/core/modal-handler";
import { ModalWindow } from "src/app/core/modal-window";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  standalone: false,
})
export class InputComponent extends ModalWindow {
  ModalExit = ModalExit;
  type: "string" | "number" = "string";
  value: string | number = null;
  message: string;
  label: string;
  helpText: string = null;
  constructor(
    public dialogRef: MatDialogRef<InputComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private mh: ModalHandler,
  ) {
    super();
    this.type = this.data?.type || "string";
    this.message = this.data?.message || "";
    this.label = this.data?.label || "";
    this.helpText = this.data?.helpText || null;
  }

  handleClose() {
    const ret = this.type == "number" ? parseInt(this.value as string) : this.value;
    this.closeModalAndReturnOutput(ret);
  }
}
